import React from "react";
import { Pagination } from "react-admin";

const MyPagination = () => {
  return <Pagination rowsPerPageOptions={[10, 25, 50, 100, 1000]} />;
};

export default MyPagination;
